import { forwardRef } from 'react';

import { Button, type ButtonProps } from 'cpool-components/input/Button';
import { ButtonVariant } from 'cpool-components/input/Button/types';

import { cn } from '~/utils/cnTailwind';

export const HeaderButton = forwardRef<HTMLButtonElement, ButtonProps>(
    ({ children, className, ...props }, ref) => {
        return (
            <Button
                ref={ref}
                variant={ButtonVariant.SECONDARY}
                {...props}
                className={cn('max-h-[30px] text-nowrap', className)}
            >
                {children}
            </Button>
        );
    },
);

HeaderButton.displayName = 'HeaderButton';
